// extracted by mini-css-extract-plugin
module.exports = {"tab":"Tab__tab___17ZMq","active":"Tab__active___yJDcG"};